var exports = {
  "k": "xe533113f--cbc8ae--container",
  "X": "xe533113f--cbc8ae--pseudolink",
};

module.exports = exports;
